import '../auth.css';
import './signin.css';
import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
import { auth, db } from '../../../firebase';
import { ImageGame } from '../../../assets';
import { onBlur, ValidationState } from '../auth.props';
import {
  FeedbackMessage,
  GoogleAuthButton,
  LineDivider,
  Spin,
} from '../../../components';
import { ROUTES } from '../../../routes';

const SignIn = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<ValidationState>({});

  const allOk =
    (email.length > 0 &&
      password.length > 0 &&
      !errors.email &&
      !errors.password) ||
    loading;

  // 🔹 comprobar perfil
  const checkUserProfile = async (uid: string) => {
    const ref = doc(db, 'users', uid);
    const snap = await getDoc(ref);

    if (!snap.exists()) return false;

    const data = snap.data();

    return Boolean(
      data.name &&
      data.lastName &&
      data.birthDate &&
      data.email &&
      data.referralCode,
    );
  };

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await signInWithEmailAndPassword(auth, email, password);

      const profileCompleted = await checkUserProfile(res.user.uid);

      if (!profileCompleted) {
        navigate(ROUTES.COMPLETE_PROFILE);
      } else {
        navigate(ROUTES.HOME);
      }
    } catch (error) {
      setErrors({ ...errors, password: 'Email o contraseña incorrectos' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="isg-auth-page">
      <img
        src={ImageGame}
        alt="Imperial Stones Game"
        className="isg-auth-image-bg"
      />
      <div className="isg-auth-form-container">
        <h1>INGRESAR</h1>

        <form className="isg-auth-form-box" onSubmit={handleEmailLogin}>
          <input
            className="isg-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'email', setErrors)}
            required
          />
          {errors.email?.length ? (
            <FeedbackMessage message={errors.email} />
          ) : (
            <></>
          )}

          <input
            className="isg-input"
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onBlur={(e) => onBlur(e.target.value, 'password', setErrors)}
            required
          />
          {errors.password?.length ? (
            <FeedbackMessage message={errors.password} />
          ) : (
            <></>
          )}

          <p className="isg-auth-recover-password">
            <Link to={ROUTES.RECOVER_PASSWORD} target="_top">
              ¿Olvidaste la contraseña?
            </Link>
          </p>

          <button
            className={`isg-form-button ${!allOk ? 'disabled' : ''}`}
            type="submit"
            disabled={!allOk}
          >
            <Spin spin={loading} size={20} className="isg-spin-floating" />
            <p className={loading ? 'loading' : ''}>Iniciar sesión</p>
          </button>

          <LineDivider />

          <GoogleAuthButton />

          <p className="isg-auth-sininup-link">
            ¿No tienes una cuenta?{' '}
            <Link to={ROUTES.SIGNUP} target="_top">
              Regístrate
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
